import type { DeleteOwnerPreferredWalkerSuccessResponse } from "wagAPI";
export const deleteOwnerPreferredWalkerResponseParser = ({
  message
}: DeleteOwnerPreferredWalkerSuccessResponse) => ({
  message
});